import axios from 'axios'

export const uploadService = async (formData) => {
  try {
    const res = await axios.post(
      process.env.REACT_APP_API_ENDPOINT + `/bin/image`,
      formData,
      {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
    )

    return res.data
  } catch (err) {
    console.log(err)
  }
}



// WEBPACK FOOTER //
// ./src/services/upload/index.js